import React from 'react';
import PropTypes from 'prop-types';
import { RichTextPropTypes } from '../../prop-types';
import { consistentString } from '../../utils/content-formatting';
// Styles
import { Header, Grid, Item, ItemsWrapper, StyledRichText } from './styles';
import { Container } from '../styled/containers';

const ContentGrid = ({
  heading,
  content,
  backgroundColor,
  border = false,
  bulleted = false,
}) => {
  if (!content) return null;

  return (
    <Grid $backgroundColor={backgroundColor}>
      <Container>
        {heading && <Header>{heading}</Header>}
        <ItemsWrapper>
          {content.map(
            (gridContent, i) =>
              gridContent && (
                <Item key={i} $border={border} $bulleted={bulleted}>
                  <StyledRichText richText={gridContent} />
                </Item>
              )
          )}
        </ItemsWrapper>
      </Container>
    </Grid>
  );
};

ContentGrid.propTypes = {
  heading: PropTypes.string,
  content: PropTypes.arrayOf(RichTextPropTypes),
  backgroundColor: PropTypes.oneOf(['grey', 'white']),
  border: PropTypes.bool,
  bulleted: PropTypes.bool,
};

export default ContentGrid;

export const ContentGridAssembly = ({ contentfulData }) => (
  <ContentGrid
    heading={contentfulData.heading}
    content={[
      contentfulData.grid1,
      contentfulData.grid2,
      contentfulData.grid3,
      contentfulData.grid4,
    ]}
    backgroundColor={consistentString(
      contentfulData.backgroundColor ?? 'white'
    )}
    border={contentfulData.border ?? false}
    bulleted={contentfulData.bulleted ?? false}
  />
);

ContentGridAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
